<template>
    <div class="box">
        <!--....删除按钮....-->
        <section class="model_bg"></section>
        <section class="my_model my_model01">
            <p class="title">{{layertitle}}<span class="closeModel">X</span></p>
            <p>{{layercontent}}</p>
            <div class="opBtn01"><a href="javascript:;" class="dialog-sure01">确定</a><a href="javascript:;" class="dialog-close01">关闭</a></div>
        </section>
        <!--.....点击成功弹窗......-->
        <div class="click_success">
            <img src="@/assets/styles/picture/me_img19.png"/>
            <p>保存成功</p>
        </div>		
	<!--..右侧盒子..-->
	<div class="me_qiug" v-loading="loading">
		<div class="qiug_tit" style="display:flex;flex-direction:row;justify-content: space-between;align-items:center">
			<p>我的供应</p>
			<a href="/member/supply_form" style="width: 90px;height: 30px;line-height: 30px;border-radius: 4px;border: 1px solid #39bf3e;font-size: 16px;color: #39bf3e;text-align: center;">发布供应</a>
		</div>
		<!--...供应信息...-->
        <div v-if="pageData.length">
            <div class="qiug_cont" v-for="item in pageData" :key="item.id">
                <a class="qiug_box" :href="'/member/supply_details?id='+item.id">
                    <div class="qiug_01">
                        <p>{{item.categoryname}}  {{item.attr_value_name}}</p>
                        <p>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</p>
                    </div>
                    <div class="qiug_02">
                        <p>{{item.price}} {{item.unit}}</p>
                        <img v-if="item.isshow == 1 && item.state == 1" src="@/assets/styles/picture/me_img03.png"/>
                        <img v-if="item.isshow == 1 && item.state == 0" src="@/assets/styles/picture/me_img22.png"/>
                        <img v-if="item.isshow == 1 && item.state == -1" src="@/assets/styles/picture/me_img21.png"/>
                        <img v-if="item.isshow == 0" src="@/assets/styles/picture/me_img01.png"/>
                    </div>
                    <p class="qiug_03"><span style="word-break: break-all;">{{item.remark}}</span></p>
                </a>
                <!--..按钮..-->
                <a href="#" v-if="item.isshow == 1 && item.state != -1" class="qiug_but_xiug an" @click="changeShow(0, item.id)">结束供应</a>
                <a :href="'/member/supply_form?id='+item.id" v-if="item.isshow == 0 || item.state == -1" class="qiug_but_end an">修改供应</a>
                <a href="#" v-if="item.isshow == 0 || item.state == -1" class="qiug_but_renew an" @click="changeShow(1, item.id)">重新供应</a>	
            </div>
        </div>
        <!--...分页..-->
        <div class="pages">
            <div class="Pagination"></div>
                <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
        </div>
        <div v-if="!loading && !pageData.length" style="text-align: center;margin-top: 20px;">您还没有发布供应信息哦</div>
	</div>	
    </div>
</template>

<style scoped>
    .qiug_cont{width:100%}
    .qiug_cont>a{width:100%}
    .qiug_cont .an{width: 120px;}
    .qiug_cont .qiug_03{
        width: 570px;
        overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    white-space: inherit;}
</style>

<script>
    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import '@/assets/styles/css/carts.css';
    import '@/assets/styles/js/jquery.pagination.js';
    import '@/assets/styles/js/carts.js';
    import { mySupply, editIsshow } from '@/api/supply/supply';

    export default {
        name: "",
        components: {},
        data: () => {
            return {
                pageCount:0,
                page_size:6,
                page:1,
                pageData:[],
                loading:true,

                layertitle:'',
                layercontent:'',
                isshow:'',
                pid:'',
            }
        },
        created() {
           this.getsupply();
        },
        methods: {
            getsupply() {
                this.loading = true;
                mySupply({
                    page_size: this.page_size,
                    page: this.page,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changePage
                        });
                        console.log(this.pageCount);
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                });
            },
            changePage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                mySupply({
                    page_size: this.page_size,
                    page: this.page,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                });
            },
            changeShow(type, id) {
                this.isshow = type;
                this.pid = id;
                this.layertitle = type == 0 ? '结束供应' : '重新供应';
                this.layercontent = type == 0 ? '您确认要结束该供应吗？' : '您确认要重新上架该供应吗？';
                $('.my_model01').css({display:'block'})
                $('.model_bg').css({display:'block'})
            },
        },
        mounted() {
            var _that = this;
            $(function(){
                $(".dialog-sure01").click(function(){
                    $('.my_model01').css({display:'none'})	
                    $('.model_bg').css({display:'none'})
                    var msg = _that.isshow == 0 ? '结束' : '上架';
                    editIsshow({
                        id: _that.pid,
                        isshow :_that.isshow
                    }).then(res => {
                        if(res.code == 0) {
                            _that.$message.success(msg+'成功！');
                        }
                        else {
                            _that.$message.error(msg+'失败，请稍后再试！');
                        }
                        _that.getsupply();
                    })
                });	
                $(".dialog-close01").click(function(){
                    $('.my_model01').css({display:'none'})	
                    $('.model_bg').css({display:'none'})

                });	
                $('.closeModel').click(function () {
                    $('.model_bg').fadeOut(300);
                    $('.my_model').fadeOut(300);
                });
            });	
		},
    }
</script>